module.exports = __webpack_public_path__ + "static/media/email-titan.9bde76ae.png";